var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-id"},[_c('div',{staticClass:"link",class:_vm.url ? 'clickable' : '',on:{"click":_vm.clickLink}},[_vm._v(_vm._s(_vm.id || '-'))]),_vm._v(" "),(_vm.nocopy !== false)?_c('v-icon',{staticClass:"copy-button",attrs:{"small":"small","title":"Copy ID"},on:{"click":_vm.copyButton}},[_vm._v("mdi-content-copy")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a95bc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/links/ItemID.vue
// module id = null
// module chunks = 